(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-rivo-promo]').forEach((bar) => {
      const button = bar.querySelector('[data-rivo-promo-toggle]');
      if (!button || button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const paused = bar.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Reanudar mensajes' : 'Pausar mensajes');
        button.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
